// Paste as assets/free-shipping-meter.js
// Keeps every [data-fsm] meter in sync after add-to-cart or quantity changes (Dawn publishes cartUpdate).
// The threshold and excluded product IDs come from attributes the snippet renders, so nothing is hard-coded here.
// Mirrors the snippet: whole-cart total like the discount's minimum purchase, hidden while an excluded item is in the cart.
(function () {
  function fmt(cents, currency) {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
  }
  function update() {
    var meters = document.querySelectorAll('[data-fsm]');
    if (!meters.length) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        meters.forEach(function (el) {
          var t = parseInt(el.dataset.threshold, 10);
          var excluded = el.dataset.excluded || ',';
          var hasExcluded = cart.items.some(function (item) {
            return excluded.indexOf(',' + item.product_id + ',') !== -1;
          });
          var rem = t - cart.total_price;
          el.hidden = !cart.requires_shipping || hasExcluded;
          el.querySelector('.fsm__fill').style.width = Math.min(100, Math.floor((cart.total_price * 100) / t)) + '%';
          el.querySelector('.fsm__text').textContent =
            rem > 0 ? "You're " + fmt(rem, cart.currency) + ' away from free shipping.' : 'Your order ships free.';
        });
      });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, update);
  }
})();